import type { CardT } from '@/types/Game'

export const dummyCards: CardT[] = [
  {
    id: 'random' + 5,
    type: 'a budget',
    rank: '9',
    suit: 'diamonds',
    value: 9,
    imageUrl: null,
    letter: 'P',
    text: 'Write out and stick to your current and future budget. Share with someone who can keep you accountable.',
    category: 'plan'
  },

  {
    id: 'random' + 8,
    type: 'spend wisely',
    rank: 'A',
    suit: 'diamonds',
    value: 10,
    imageUrl: null,
    letter: 'N',
    text: 'To plan, save and invest for your future, match your spending to your priorities.',
    category: 'plan'
  },
  {
    id: 'random' + 9,
    type: 'Pay yourself first',
    rank: 'K',
    suit: 'spades',
    value: 10,
    imageUrl: null,
    letter: 'V',
    text: 'Avoid sliding into bankruptcy or poverty in the event of unforeseen expenses; create an emergency fund.',
    category: 'save'
  },

  {
    id: 'random' + 16,
    type: 'Safeguard your identity and rating',
    rank: '8',
    suit: 'spades',
    value: 8,
    imageUrl: null,
    letter: 'V',
    text: 'Manage and guard your credit score by avoiding unnecessary debt.',
    category: 'save'
  },

  {
    id: 'random' + 19,
    type: 'Pay yourself first',
    rank: '7',
    suit: 'spades',
    value: 7,
    imageUrl: null,
    letter: 'E',
    text: 'Take control of the future that you want. Pay yourself first to help you reach long term goals and handle your needs.',
    category: 'save'
  },
  {
    id: 'random' + 29,
    type: 'for you',
    rank: 'J',
    suit: 'hearts',
    value: 10,
    imageUrl: null,
    letter: 'T',
    text: 'Stick with your retirement savings and investment plan through thick and thin.',
    category: 'invest'
  },

  {
    id: 'random' + 17,
    type: 'Safeguard your identity and rating',
    rank: '8',
    suit: 'clubs',
    value: 8,
    imageUrl: null,
    letter: 'V',
    text: 'If you must take a loan, avoid missing repayments to ensure you maintain a good credit rating.',
    category: 'save'
  }
]
